const EMAILS = {
  EVENTS_FEEDBACK: 'eventsfeedback@seismic.com',
  LEARN_FEEDBACK: 'learnfeedback@seismic.com',
  PRACTICE_FEEDBACK: 'practicefeedback@seismic.com',
  INSIGHTS_FEEDBACK: 'ewible@seismic.com',
  SORTING_FEEDBACK: 'sortingfeedback@seismic.com',
  MATCHING_FEEDBACK: 'matchingfeedback@seismic.com',
  ELEARNING_FEEDBACK: [
    'tchan@seismic.com',
    'nsalazar@seismic.com',
    'jdoan@seismic.com',
    'nraisuni@seismic.com',
    'pfowler@seismic.com',
  ].toString(),
  TEMPLATE_FEEDBACK: 'lessontemplatesfeedback@seismic.com',
};

export default EMAILS;
